/* Hide the ".cart__checkout" button if Loop Checkout+ loaded*/
document.addEventListener('DOMContentLoaded', _ => {

  // Show/hide the "cart__checkout-button" button that duplicates offset "checkout+" button
  function toggleCheckoutButton(offsetExists) {
    const checkoutBtn = document.querySelector('.cart__checkout.new-checkout-link');
    if (checkoutBtn) {
      checkoutBtn.style.display = offsetExists ? 'none' : 'flex';
    }
  }

  function checkOffset() {
    const offset = document.querySelector('.offset-cart-offer-container') !== null;
    toggleCheckoutButton(offset);
  }

  // Set up the observer to watch the main cart for changes
  const cartDrawer = document.querySelector('.cart__aside');
  if (cartDrawer) {
    const observer = new MutationObserver(checkOffset);
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  checkOffset();
  
});